"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Spinner = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  src/form/Spinner.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 1/6/21.
//  Copyright © 2021-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var propDoc = {
  size: {
    required: false,
    defaultValue: "16",
    type: "number",
    description: "Size of the spinner"
  }
};
var demoProps = {};

var Spinner = function Spinner(props) {
  var className = props.className,
      style = props.style;
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(className, style, styles.root)
  });
};

exports.Spinner = Spinner;
Spinner.propDoc = propDoc;
Spinner.demoProps = demoProps;
var _default = Spinner;
exports["default"] = _default;
var Keyframes = {
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
};

var useStylesheet = function useStylesheet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size;

  var _useTheme = (0, _providers.useTheme)(),
      primary = _useTheme.primary;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        fontSize: size * 0.085,
        width: "11em",
        height: "11em",
        borderRadius: "50%",
        background: "linear-gradient(to right, ".concat(primary, " 10%, rgba(255, 255, 255, 0) 42%)"),
        position: "relative",
        transform: "translateZ(0)",
        animationName: [Keyframes],
        animationDuration: "1.4s",
        animationTimingFunction: "linear",
        animationIterationCount: "infinite",
        ":before": {
          width: "50%",
          height: "50%",
          background: primary,
          borderRadius: "100% 0 0 0",
          position: "absolute",
          top: 0,
          left: 0,
          content: ""
        },
        ":after": {
          background: "transparent",
          width: "75%",
          height: "75%",
          borderRadius: "50%",
          content: "",
          margin: "auto",
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        }
      }
    });
  }, [size, primary]);
};